const GamesTypes = {
  SET_GAMES_LOADING: 'GAMES/SET_GAMES_LOADING',
  SET_GAMES_FAILURE: 'GAMES/SET_GAMES_FAILURE',
  SET_GAMES_SUCCESS: 'GAMES/SET_GAMES_SUCCESS',
};

export default GamesTypes;